import { atom } from 'jotai';

export const sectionProgress = atom<number>(0);
